









import { Component, Vue } from 'vue-property-decorator';
import Notification from './components/services/Notification.vue';
import * as api from '@/api/api';

// フィルタ
Vue.filter('zeroformat', (value: number, length: number): string | null => {
  return ('0000000000' + value).slice(-length);
});
Vue.filter('commaformat', (value: number): string | null => {
  return Number(value).toLocaleString();
});
Vue.filter('gamedate', (value: api.GameDateTime): string => {
  return api.GameDateTime.toFormatedString(value);
});
Vue.filter('realdate', (value: api.DateTime): string => {
  return api.DateTime.toFormatedString(value);
});
Vue.filter('shortrealdate', (value: api.DateTime): string => {
  return api.DateTime.toShortFormatedString(value);
});
Vue.filter('torealdate', (value: api.GameDateTime, system: api.SystemData): api.DateTime => {
  if (value && system) {
    return api.GameDateTime.toRealDate(value, system);
  }
  return new api.DateTime();
});
Vue.filter('charafromname', (chara: api.Character | number): string => {
  const from = typeof(chara) === 'number' ? chara : chara.from;
  return from === 1 ? '武家' :
    from === 2 ? '官吏' :
    from === 3 ? '商人' :
    from === 4 ? '技師' :
    from === 5 ? 'ＡＩ' :
    from === 6 ? '胡人' :
    from === 7 ? '農家' :
    from === 8 ? '兵家' :
    from === 9 ? '学者' :
    from === 10 ? '参謀' :
    from === 11 ? '儒家' :
    from === 12 ? '道家' :
    from === 13 ? '仏僧' : 'なし';
});

@Component({
  components: {
    Notification,
  },
})
export default class App extends Vue {
}
